import { Component, Input } from '@angular/core';

import { OnlinePaymentsService } from './online-payments.service';
import { SessionService }     from '../sessions/session.service';

@Component({
  selector   : 'wor-online-payment-error',
  template: require('./online-payment.error.component.html')
})
export class OnlinePaymentErrorComponent {
  error = this.sessionObjAPI.get(this.onlinePaymentsService.errorKey);

  @Input() status : string;

  constructor (
    private onlinePaymentsService: OnlinePaymentsService,
    private sessionObjAPI        : SessionService
  ) {}

  getErrorMessage () : string {
    return this.error?.message
      ? this.error.message
      : this.error;
  }
}
